import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styled from "styled-components";

const API_BASE_URL = "https://admin.shopaholics.ge/api";

const LoginPage = ({ setUser }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
  
        // Ensure parsedUser is an object before setting state
        if (typeof parsedUser === "object" && parsedUser !== null) {
          setUser(parsedUser);
        } else {
          console.error("❌ Invalid user data in localStorage:", storedUser);
          localStorage.removeItem("user"); // Remove invalid data
        }
      } catch (error) {
        console.error("❌ Error parsing stored user:", error);
        localStorage.removeItem("user"); // Remove corrupted data
      }
    }
  }, []);
    
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await axios.post(`${API_BASE_URL}/login_user.php`, formData, {
        headers: { "Content-Type": "application/json" },
      });
    
      console.log("🔍 API Response:", response.data); // Debugging
    
      if (response.data.error) {
        setError(response.data.error);
        return;
      }
    
      const user = response.data.user;
    
      if (!user || typeof user !== "object") {
        setError("Invalid user data received.");
        return;
      }
    
      if (!user.is_admin) {
        setError("Access denied. Only admins can log in.");
        return;
      }
    
      localStorage.setItem("user", JSON.stringify(user));
      setUser(user);
      navigate("/");
    
    } catch (error) {
      setError("Login failed. Please try again.");
      console.error("Login error:", error);
    }
    };

  return (
    <Container>
      <LoginBox>
        <h2>Login</h2>
        {error && <ErrorMessage>{error}</ErrorMessage>}
        <Form onSubmit={handleLogin}>
          <Label>Email:</Label>
          <Input type="email" name="email" value={formData.email} onChange={handleChange} required />
          <Label>Password:</Label>
          <Input type="password" name="password" value={formData.password} onChange={handleChange} required />
          <Button type="submit">Login</Button>
        </Form>
      </LoginBox>
    </Container>
  );
};

export default LoginPage;

/* ✅ Styled Components */
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: linear-gradient(135deg, #1e1e1e, #383838);
`;

const LoginBox = styled.div`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
  text-align: center;
  width: 320px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Label = styled.label`
  font-size: 1rem;
  color: #ffffff;
  text-align: left;
`;

const Input = styled.input`
  padding: 0.8rem;
  font-size: 1rem;
  border: none;
  border-radius: 8px;
  outline: none;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  transition: 0.3s;

  &::placeholder {
    color: rgba(255, 255, 255, 0.6);
  }

  &:focus {
    background: rgba(255, 255, 255, 0.3);
  }
`;

const Button = styled.button`
  padding: 0.8rem;
  font-size: 1rem;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  background: #facc15;
  color: #1e1e1e;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background: #ffd700;
  }
`;

const ErrorMessage = styled.p`
  color: #ff4d4d;
  font-size: 0.9rem;
  margin-bottom: 1rem;
`;
